export const configurationColumnTableDA = {
  activityDate: true,
  type: true,
  depositNames: true,
  productNames: true,
  asIsQuantity: true,
  userNames: true,
  movement: true,
};
